import { render, staticRenderFns } from "./investmentCluesIpocity.vue?vue&type=template&id=4aed1542&"
import script from "./investmentCluesIpocity.vue?vue&type=script&lang=js&"
export * from "./investmentCluesIpocity.vue?vue&type=script&lang=js&"
import style0 from "./investmentCluesIpocity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports